export default "__VITE_ASSET__BmCpKvTF__"